import { API_BASE_URL } from "./api-config";

const BASE_URL = `${API_BASE_URL}/api/Worker`;

export const WorkerApi = {
  getPhotoUrl(organizationId: string, workerId: string) {
    return `${BASE_URL}/${organizationId}/${workerId}/photo`;
  },
};
